import { Link } from 'react-router-dom'
import { formatNumber } from '../../../../utils/CurrencyFormatter'
import { getCSSVariableValue } from '../../../../_metronic/assets/ts/_utils'
import { getInitials } from '../../../../utils/Utils'
import {
  RemoveCompanyMutation,
  RemoveCompanyMutationVariables,
  useAddOrRemoveStarredCompaniesMutation,
  useGetNewWatchlistsQuery,
  useGetWatchlistByIdQuery,
  useRemoveCompanyMutation,
  WatchlistEntityType,
} from '../../../../generated/graphql'
import { graphqlRequestClient, queryClient } from '../../../../queries/client'
import Toast, { ToastType } from '../../../../utils/toast'
import { KTSVG } from '../../../../_metronic/helpers'
import { useEffect, useRef } from 'react'
import { useCompanyNameStore } from '../../../../store/companyNameStore'
import { MenuComponent } from '../../../../_metronic/assets/ts/components'

export function CompanyNameRender(data: any) {
  const companyNameStore = useCompanyNameStore()
  const mutateStarredCompany = useAddOrRemoveStarredCompaniesMutation<Error>(
    graphqlRequestClient,
    {
      onSuccess: (result, variables) => {
        // Invalidate the main watchlists query
        queryClient.invalidateQueries(useGetNewWatchlistsQuery.getKey())
        // Invalidate the specific watchlist details query if we have the watchlist ID
        if (variables.input?.watchlistId) {
          queryClient.invalidateQueries(
            useGetWatchlistByIdQuery.getKey({ input: { id: variables.input.watchlistId } })
          )
        }
        const action = variables.input?.isRemove ? 'Removed From' : 'Added To'
        Toast(`Company ${action} Starred Companies`, ToastType.success)
      },
      onError: (error: any) => {
        Toast(`${error.response.errors[0].message}`, ToastType.error)
      },
    },
    {}
  )

  const isInvestorWatchlist = data.data.watchlistType === WatchlistEntityType.Investor

  return (
    <div className='pb-2'>
      {data.data.companyId ? (
        <div className='d-flex flex-row'>
          {!isInvestorWatchlist && (
            <span className='pe-2 py-2'>
              {data.data.starredCompanies?.includes(data.data.companyId) ? (
                <img
                  src={'/media/icons/duotune/general/star-filled.svg'}
                  alt=''
                  style={{
                    cursor: 'pointer',
                  }}
                  onClick={() => {
                    mutateStarredCompany.mutate({
                      input: {
                        companyId: data.data.companyId,
                        companyName: data.data.companyName,
                        isRemove: true,
                        watchlistId: data.data.watchlistId,
                      },
                    })
                  }}
                />
              ) : (
                <img
                  src={'/media/icons/duotune/general/star-light.svg'}
                  alt=''
                  style={{
                    cursor: 'pointer',
                  }}
                  onClick={() => {
                    mutateStarredCompany.mutate({
                      input: {
                        companyId: data.data.companyId,
                        companyName: data.data.companyName,
                        isRemove: false,
                        watchlistId: data.data.watchlistId,
                      },
                    })
                  }}
                />
              )}
            </span>
          )}
          <span className=''>
            {data.data.logo && data.data.logo !== '' && data.data.logo !== 'NA' ? (
              <div className='symbol symbol-40px h-40px w-40px symbol-fixed position-relative'>
                <img src={data.data.logo} alt='' />
              </div>
            ) : (
              <div className='bg-secondary rounded h-40px w-40px fw-bold d-flex justify-content-center align-items-center'>
                <p
                  className='mb-0 fs-1'
                  style={{
                    color: getCSSVariableValue('--kt-donut-' + ((1 + 9) % 10)),
                  }}
                >
                  {getInitials(data.data.companyName)}
                </p>
              </div>
            )}
          </span>
          <span className='ps-4 py-2'>
            <Link
              className='fs-base fw-bold mb-0 text-gray-800 text-hover-primary'
              to={`/company/summary/HISSA/${data.data.companyId}`}
              onClick={() => {
                companyNameStore.setCompanyName(data.data.companyName || '')
                companyNameStore.setCompanyCurrency(data.data.companyCurrency || 'INR - ₹')
              }}
            >
              <h6
                className={`${data.data.dba ? '' : 'pt-2'} m-0 fw-bold text-hover-primary`}
                data-toggle='tooltip'
                data-placement='top'
                title={data.data.dba || data.data.companyName}
              >
                {data.data.dba || data.data.companyName}
              </h6>
            </Link>
            {data.data.dba && <span className='fs-8 text-muted'>{data.data.companyName}</span>}
          </span>
        </div>
      ) : (
        <p className='fw-bold'> {data.data.companyName}</p>
      )}
    </div>
  )
}

export function TotalRoundsRoundRender(data: any) {
  return (
    <div className='py-3'>
      <p className='m-0'>{data.data.noOfRound}</p>
    </div>
  )
}

export function IndustryRender(data: any) {
  return (
    <div className='py-3'>
      <p className='m-0'>{data.data.industry || '-'}</p>
    </div>
  )
}

export function ValuationRender(data: any) {
  return (
    <div className='py-3'>
      <p className='m-0'>
        {formatNumber({
          value: data.data.valuation,
          format: data.data.userCurrencyFormat,
        })}
      </p>
    </div>
  )
}
export function LatestRaiseRender(data: any) {
  return (
    <div className='py-3'>
      <p className='m-0'>
        {formatNumber({
          value: data.data.latestRaise,
          format: data.data.userCurrencyFormat,
        })}
      </p>
    </div>
  )
}
export function EsopHoldingRender(data: any) {
  return (
    <div className='py-3'>
      <p className='m-0'>
        {formatNumber({
          value: data.data.esopHolding,
          format: data.data.userCurrencyFormat,
        })}
      </p>
    </div>
  )
}
export function FounderHoldingRender(data: any) {
  return (
    <div className='py-3'>
      <p className='m-0'>
        {formatNumber({
          value: data.data.founderHolding,
          format: data.data.userCurrencyFormat,
        })}
      </p>
    </div>
  )
}

export function TotalRaisedRender(data: any) {
  return (
    <div className='py-3'>
      <p className='m-0'>
        {formatNumber({
          value: data.data.totalRaise,
          format: data.data.userCurrencyFormat,
        })}
      </p>
    </div>
  )
}

export function TotalInvestmentRender(data: any) {
  return (
    <div className='py-3'>
      <p className='m-0'>
        {formatNumber({
          value: data.data.totalInvestment,
          format: data.data.userCurrencyFormat,
        })}
      </p>
    </div>
  )
}

export function CurrentValueRender(data: any) {
  return (
    <div className='py-3'>
      <p className='m-0'>
        {formatNumber({
          value: data.data.currentValue,
          format: data.data.userCurrencyFormat,
        })}
      </p>
    </div>
  )
}

export function MoicRender(data: any) {
  return (
    <div className='py-3'>
      <p className='m-0'>{data.data.moic ? `${data.data.moic.toFixed(2)}x` : '-'}</p>
    </div>
  )
}

export function XirrRender(data: any) {
  return (
    <div className='py-3'>
      <p className='m-0'>
        {data.data.xirr !== null && data.data.xirr !== undefined
          ? `${data.data.xirr.toFixed(2)}%`
          : '-'}
      </p>
    </div>
  )
}

export function FdbPercentageRender(data: any) {
  return (
    <div className='py-3'>
      <p className='m-0'>
        {data.data.fdbPercentage ? `${data.data.fdbPercentage.toFixed(2)}%` : '-'}
      </p>
    </div>
  )
}

export function ActionRender(data: any) {
  const deleteBtnRef = useRef<HTMLButtonElement | null>(null)
  useEffect(() => {
    setTimeout(() => {
      MenuComponent.reinitialization()
    }, 50)
  }, [data])

  const mutateRemoveCompany = useRemoveCompanyMutation<Error>(
    graphqlRequestClient,
    {
      onSuccess: (
        data: RemoveCompanyMutation,
        variables: RemoveCompanyMutationVariables,
        _context: unknown
      ) => {
        // Invalidate the main watchlists query
        queryClient.invalidateQueries(useGetNewWatchlistsQuery.getKey())
        // Invalidate the specific watchlist details query if we have the watchlist ID
        if (variables.input?.id) {
          queryClient.invalidateQueries(
            useGetWatchlistByIdQuery.getKey({ input: { id: variables.input.id } })
          )
        }
        Toast('Company Removed From Watchlist!', ToastType.success)
      },
    },
    {}
  )

  function handleRemoveCompany(e: React.MouseEvent, watchlistId: number, companyId: string) {
    e.stopPropagation()
    // Disable indicator after 3 seconds
    deleteBtnRef.current?.setAttribute('data-kt-indicator', 'on')
    setTimeout(() => {
      // Activate indicator
      deleteBtnRef.current?.removeAttribute('data-kt-indicator')
    }, 3000)
    e.preventDefault()

    mutateRemoveCompany.mutate({ input: { id: watchlistId, companyId: companyId } })
  }

  const isInvestorWatchlist = data.data.watchlistType === WatchlistEntityType.Investor

  // Don't render delete button for investor watchlists
  if (isInvestorWatchlist) {
    return null
  }
  const editOptions = ['Delete Company']

  const actionMenu = () => {
    let newOptions = editOptions
    return newOptions.map((option) => {
      return (
        <label
          key={option}
          className='form-check-custom py-3 bg-hover-primary text-hover-white'
          onClick={(e) => {
            if (option === 'Delete Company') {
              handleRemoveCompany(e, data.data.watchlistId, data.data.companyId)
            }
          }}
        >
          <span className='form-check-label fs-base ms-6 fw-normal cursor-pointer  '>{option}</span>
        </label>
      )
    })
  }

  return (
    <div className='px-0'>
      <button
        type='button'
        className='btn btn-sm btn-icon btn-color-gray-400 btn-active-secondary'
        data-kt-menu-trigger='click'
        data-kt-menu-placement='bottom-end'
        data-kt-menu-flip='top-end'
      >
        <KTSVG
          path='/media/icons/duotune/general/gen052.svg'
          className='svg-icon-muted svg-icon-2x'
        />
      </button>
      <div
        className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-800 menu-state-bg-light-primary fw-bold w-200px py-3'
        data-kt-menu='true'
      >
        {actionMenu()}
      </div>
    </div>
  )
}
